import { createContext, useContext } from "react";

export interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  setAuthenticated: (isAuthenticated: boolean, authToken?: string) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthState>({
  token: null,
  isAuthenticated: false,
  setAuthenticated: (_, authToken) => {},
  logout: () => {}
});

export const useAuthContext = (): AuthState => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext debe ser usado dentro de un AuthProvider");
  }
  return context;
};
